import React, { useMemo } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { Layout } from './solteq-react/navigation/Layout';
import { connect } from 'react-redux';
import { get as _get } from 'lodash';
import { reduxStateMap, withReducerName } from '../redux/reduxMap';
import { configurationThunk } from '../redux/registryThunks';
import LoadingIndicator from './LoadingIndicator';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PrivacyPolicyModal from './PrivacyPolicyModal';
import TermsOfUseModal from './TermsOfUseModal';
import authService from '../authService';

const getDrawerHeight = (isLogon) => (isLogon ? '64px' : '83px');

const useStyles = makeStyles((theme) => ({
    stretch: {
        flexGrow: 1,
        display: 'flex',
        width: '100vw',
        flexFlow: 'column',
        overflow: 'auto'
    },
    divider: {
        backgroundColor: 'linear-gradient(359deg, #3fc66b 108%, #69c9f3 -3%);',
        height: '50px'
    },
    inputsContainer: {
        justifyContent: 'flex-end'
    },
    inputContainer: {
        alignItems: 'center',
        display: 'flex'
    },
    optionBar: {
        '& [class*=makeStyles-actionContainer]': {
            display: 'none'
        }
    },
    smallInput: {
        width: 150
    },
    largeInput: {
        width: 250
    },
    body: {
        flexGrow: 1
    },
    outerLayout: {
        display: 'flex',
        flexGrow: 1,
        height: '100vh',
        overflowY: 'hidden',
        flexFlow: 'column'
    }
}));

export const TrafiLayout = connect(
    (state) => ({
        configuration: _get(state, withReducerName(reduxStateMap.CONFIGURATION))
    }),
    (dispatch) => ({
        getConfiguration: () => dispatch(configurationThunk())
    })
)(({ isLogon, getConfiguration, configuration, renderContent }) => {
    const isInfoDirectionRow = useMediaQuery('(min-width:1460px)');
    const isInfoVisible = useMediaQuery('(min-width:800px)');
    const isAspectRatioSmallerThanBackground = useMediaQuery(`(min-aspect-ratio: 8576/5694)`);

    const classes = useStyles();
    const [userName, setUserName] = React.useState('');
    const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = React.useState(false);
    const [isTermsOfUseOpen, setIsTermsOfUseOpen] = React.useState(false);
    React.useEffect(() => {
        // Ensure auth and config
        if (isLogon) {
            setUserName(authService.getUsername());
            getConfiguration();
        }
        //eslint-disable-next-line
    }, [authService, getConfiguration, setUserName, isLogon]);
    const Content = ((!isLogon || configuration) && renderContent({ configuration })) || <LoadingIndicator />;
    const TopLeftStuff = useMemo(() => {
        return (
            <Grid
                container
                alignItems="center"
                direction="row"
                style={{
                    width: `calc(100% - ${!isLogon ? '100px' : isInfoDirectionRow ? '350px' : '300px'})`,
                    height: getDrawerHeight(isLogon),
                    position: 'absolute',
                    paddingLeft: '40px',
                    minWidth: '180px',
                    background: isLogon ? 'black' : undefined,
                    zIndex: 3000,
                    margin: 0
                }}
            >
                {isInfoVisible && !(isLogon && !isInfoDirectionRow) && (
                    <Grid item sm={2} xs={1}>
                        <img src="/solteq_logo.png" style={{ width: '125px', height: 'auto' }} alt="" />
                    </Grid>
                )}
                <Grid
                    item
                    container
                    direction={isInfoDirectionRow ? 'row' : 'column'}
                    sm={10}
                    xs={11}
                    justifyContent={isInfoVisible && !(isLogon && !isInfoDirectionRow) && 'space-evenly'}
                    style={{
                        background: isLogon ? 'black' : undefined,
                        color: 'white',
                        paddingLeft: !isInfoDirectionRow && isInfoVisible && !(isLogon && !isInfoDirectionRow) ? '100px' : undefined
                    }}
                >
                    {(!isInfoVisible || (isLogon && !isInfoDirectionRow)) && (
                        <Grid item>
                            <img src="/solteq_logo.png" style={{ width: '100px', height: 'auto' }} alt="" />
                        </Grid>
                    )}
                    <Grid item>
                        <Grid container direction={isInfoDirectionRow ? 'column' : 'row'}>
                            <Typography
                                variant={isInfoVisible ? 'body1' : 'caption'}
                                onClick={() => setIsPrivacyPolicyOpen(true)}
                                style={{ cursor: 'pointer', marginRight: isInfoDirectionRow ? 0 : '10px' }}
                            >
                                <b>Rekisteriseloste</b>
                            </Typography>
                            <Typography variant={isInfoVisible ? 'body1' : 'caption'} onClick={() => setIsTermsOfUseOpen(true)} style={{ cursor: 'pointer' }}>
                                <b>Käyttöehdot</b>
                            </Typography>
                        </Grid>
                    </Grid>
                    {isInfoVisible && !(isLogon && !isInfoDirectionRow) && (
                        <Grid item style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                            <Typography>
                                <b>Yhteystiedot</b> Revontulenkuja 1, 02100 Espoo
                            </Typography>
                        </Grid>
                    )}
                    {isInfoVisible && !(isLogon && !isInfoDirectionRow) && (
                        <Grid item style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                            <Typography>
                                <b> Asiakastuki</b> auto.help@solteq.com | 09 5422 5433
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        );
    }, [isInfoVisible, setIsPrivacyPolicyOpen, setIsTermsOfUseOpen, isInfoDirectionRow, isLogon]);
    return (
        <>
            <div className={classes.outerLayout}>
                <PrivacyPolicyModal isOpen={isPrivacyPolicyOpen} handleClose={() => setIsPrivacyPolicyOpen(false)} />
                {(isLogon || isTermsOfUseOpen) && <TermsOfUseModal isOpen={isTermsOfUseOpen} handleClose={() => setIsTermsOfUseOpen(false)} />}
                <div className={classes.stretch}>
                    <style
                        dangerouslySetInnerHTML={{
                            __html: `
                        .MuiToolbar-root { height: ${getDrawerHeight(isLogon)}, background: ${isLogon ? 'black' : undefined} }
                        .MuiToolbar-regular { min-height: 64px }
                        main { padding: 0px !important; padding-top: calc(${getDrawerHeight(isLogon)} - 64px) !important }
                        `
                        }}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            backgroundImage: 'url("/bg_image2.png")',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: isAspectRatioSmallerThanBackground ? '100% auto' : 'auto 100%'
                        }}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            opacity: '0.5',
                            backgroundImage: 'linear-gradient(119deg, #3fc66b, #8dd7f7 100%)',
                            backgroundSize: '100% 100%'
                        }}
                    />
                    {isLogon ? (
                        <Layout
                            logo="/solteq_logo.png"
                            userName={userName}
                            classes={{ divider: classes.divider, drawer: classes.drawer }}
                            onLogOut={() => {
                                authService.logout();
                                window.location.href = '/';
                            }}
                            logoutLabel="Kirjaudu ulos"
                            beforeSettingsMenuArea={TopLeftStuff}
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    width: '100%',
                                    height: `calc(100% - ${getDrawerHeight(true)})`,
                                    display: 'flex'
                                }}
                            >
                                {Content}
                            </div>
                        </Layout>
                    ) : (
                        <>
                            <div
                                style={{
                                    position: 'absolute',
                                    width: '100%'
                                }}
                            >
                                {TopLeftStuff}
                            </div>
                            <div
                                style={{
                                    position: 'absolute',
                                    marginTop: getDrawerHeight(isLogon),
                                    width: '100%',
                                    height: `calc(100% - ${getDrawerHeight(isLogon)})`
                                }}
                            >
                                {Content}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
});
// eslint-disable-next-line
export const WithTrafiLayout = (Wrapped, isLogon) => (props1) => <TrafiLayout renderContent={(props2) => <Wrapped {...props1} {...props2} />} isLogon={isLogon} />;
